/*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/

import React, {useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import '../css/App.css';
import '../css/Home.css';
import '../css/Configchild.css';
import 'bootstrap/dist/css/bootstrap.css';
import Instance from '../Objects/Axios';
import alertinstance from '../Objects/Alert';
import Spin from './Spinner/Spin';
//main function for module
const Configchild = ({icon}) => {
  let navigate = useNavigate();
    const [cdnUrl,setcdnUrl]= useState("");
    const [apiHostname,setapiHostname]= useState("");
    const [apiKey,setapiKey]= useState("");
    const [secretKey,setsecretKey] = useState("");
    const [desKey,setdesKey]= useState("");
    const [rsKey,setrsKey]= useState("");
    const [viKey,setvikey]= useState("");
    const [staticHeader,setstaticHeader]= useState("");
    const [profileCdn,setprofileCdn]=useState('')
    const [stripeAPIKey, setstripeAPIKey] = useState('')
    const [paytmMID,setpaytMID]=useState('')
    const [upiID,setupiID]=useState('')
    const [trailercdn,settrailercdn]=useState('')
    const [googleInapp,setgoogleInapp]=useState({label:'',value:''})
    const [loading,setloading]=useState(false)
    const [secure,setSecure]=useState(true);
    const data = {
      cdnUrl :cdnUrl,
      apiHostname:apiHostname,
      profileCdn:profileCdn,
      stripeAPIKey:stripeAPIKey,
      paytmMID:paytmMID,
      upiID:upiID,
      trailerCdn:trailercdn,
      googleInapp:googleInapp.value,
      contentOn:secure
    }
    //render the content only once at a time
    useEffect(() => {
        getconfig();
        },[])

    function getconfig(){
      /*axios({
            method: "GET",
            url: "https://cms.laltenstaging.xyz/cms/api/v1.0/getConfig",
            data: '',
            headers: { 
            "Content-Type": "application/json",
            "API-KEY":process.env.REACT_APP_API_KEY,
           "access-token": Token
          },   
          })*/
        Instance.get('/getConfig')
        .then(function (res) {
          const pre = res.data.list;
          if(pre.length >= 15){
            setcdnUrl(pre[6].value) 
            setapiHostname(pre[0].value);
            setapiKey(pre[2].value);
            setsecretKey(pre[3].value);
            setstaticHeader(pre[7].value);
            setdesKey(pre[5].value);
            setrsKey(pre[8].value);
            setvikey(pre[9].value);
            setpaytMID(pre[12].value)
            setstripeAPIKey(pre[13].value)
            setupiID(pre[14].value)
            setprofileCdn(pre[11].value)
            settrailercdn(pre[15].value)
            setgoogleInapp({label:pre[16].value , value:pre[16].value})
            if(pre[18].value === "true"){
              setSecure(true)
            }else{
              setSecure(false)
            }
          }
        }).catch(err=>{
          if(err.response){
            if(err.response.status === 403){
              localStorage.clear();
              navigate('/login/error?message=session token expired please login again !')
            }
          }
        })
  }

  const options =[
    {
      label:'Both',
      value:'both'
    },
    {
      label:'India',
      value:'india'
    },
    {
      label:'International',
      value:'international'
    }
  ]
  const handle=(e)=>{
    
    setgoogleInapp(e)
  }

    const addconfig=(e)=>{
      e.preventDefault()
      setloading(true)
      Instance.post('/addConfig',data)
      .then(res=> {
        setloading(false)
        alertinstance(res)
      }).catch(err=>{
        setloading(false)
        console.log(err)
      })
    }
        return (
        <>
        {!loading ? '':<Spin/>}
        <div className="config content">
            <div className="alert alert-primary">  <i className="fa fa-bars" onClick={icon}></i>
                <span className='leftpush'> Configuration Details </span>
            </div>
            <p className='path p-3 mt-2'>Home / Configuration / </p>
            <div className="configchild">
                    <form className="configform" onSubmit={addconfig}>
                                    <label>CDN Static</label><input type="text" value={cdnUrl} onChange={(e)=> setcdnUrl(e.target.value)}/><br/>
                                    <label>Header</label><input type="text" disabled value={staticHeader}/><br/>
                                    <label>API Host Name</label><input type="text" value={apiHostname} onChange={(e)=> setapiHostname(e.target.value)}/><br/>
                                    <label>API Key</label><input type="text" disabled value={apiKey}/><br/>
                                    <label>Profile CDN Url</label><input type="text"  value={profileCdn} onChange={(e)=> setprofileCdn(e.target.value)}/><br/>
                                    <label>Paytm MID</label><input type="text"  value={paytmMID} onChange={(e)=> setpaytMID(e.target.value)}/><br/>
                                    <label>Stripe ClientId</label><input type="text"  value={stripeAPIKey} onChange={(e)=> setstripeAPIKey(e.target.value)}/><br/>
                                    <label>Upi Id</label><input type="text"  value={upiID} onChange={(e)=> setupiID(e.target.value)}/><br/>
                                    <label>API Secret key</label><input type="text" disabled value={secretKey}/><br/>
                                    <label>Trailer CDN Url</label><input type="text" value={trailercdn} onChange={(e)=> settrailercdn(e.target.value)} /><br/>
                                    <label>DES Key</label><input type="text" disabled value={desKey} /><br/>      
                                    <span style={{'display':'inline-flex','width':'100%'}}><label>RS Key</label>
                                    <textarea disabled className='form-control' value={rsKey} /></span><br/>
                                    <span style={{'display':'inline-flex','width':'100%'}}><label>VI Key</label><textarea className='form-control' disabled value={viKey}/></span><br/><br/>
                                    <div className='secure'>
                                    <input type="checkbox"  checked={secure} onChange={e => setSecure(e.target.checked)}/>
                                    <p> 18+ Content Visibility</p>
                                    </div>
                                
                                    <span style={{'display':'inline-flex','width':'100%'}}><label>Google Inapp</label>
                                    <Select style={{'width':'400px'}} options={options} value={googleInapp} placeholder="Select google in app setting*" onChange={handle}></Select></span>
                                    <br/>
                                    <button type="submit" className='btn btn-primary mt-2'>save</button>
                    </form>
                </div>
        </div>
        </>
    )
}

export default Configchild
